import { buildResponsiveCSS } from '../../../utils/css.mjs';
import { StyledLineSeparator } from '../../Basic/LineSeparator/LineSeparator.styles.mjs';
import { StyledList as StyledList$1 } from '../../Basic/Lists/HorizontalList/Horizontal.styles.mjs';
import { StyledList } from '../../Basic/Lists/VerticalList/VerticalList.styles.mjs';
import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import { StyledText } from '../../Typography/Text/Text.styles.mjs';
import styled from 'styled-components';

const StyledFooterGrid = styled.div `
  display: grid;
  grid-template-rows: repeat(7, auto-fill);
  grid-template-columns: repeat(1, auto-fill);
  row-gap: 2.5rem;
  padding-bottom: 2.5rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    grid-template-rows: repeat(3, auto-fill);
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: repeat(5, 1fr);
  }
`;
const StyledFooterGridItem = styled.div `
  ${props => buildResponsiveCSS('grid-area', props.area)}
`;
const StyledTopListGridItem = styled(StyledFooterGridItem) `
  justify-self: center;

  ${StyledHeading} {
    margin: 0 0 1.375rem;
    font-size: ${props => props.theme.typography.text.small.fontSize};
    font-weight: ${props => props.theme.typography.fontWeight.medium};
    line-height: ${props => props.theme.typography.text.small.lineHeight};
    text-align: center;
  }

  ${StyledList} {
    gap: 1rem;
    justify-items: center;
  }

  ${StyledText} {
    font-size: ${props => props.theme.typography.text.tiny.fontSize};
    line-height: ${props => props.theme.typography.text.tiny.lineHeight};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    justify-self: flex-start;

    ${StyledHeading} {
      text-align: start;
    }

    ${StyledList} {
      justify-items: flex-start;
    }
  }
`;
const StyledBottomListGridItem = styled(StyledFooterGridItem) `
  justify-self: center;

  ${StyledList$1} {
    margin: 0;
    gap: 1rem;
  }

  ${StyledHeading} {
    font-size: ${props => props.theme.typography.text.tiny.fontSize};
    line-height: ${props => props.theme.typography.text.tiny.lineHeight};
    font-weight: ${props => props.theme.typography.fontWeight.regular};
    color: ${props => props.theme.colors.mutedTextColor};
    text-transform: none;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    justify-self: flex-start;
  }
`;
const StyledCopyrightGridItem = styled(StyledFooterGridItem) `
  ${StyledText} {
    margin: 0;
    text-align: center;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    ${StyledText} {
      text-align: start;
    }
  }
`;
const StyledLineSeparatorGridItem = styled(StyledFooterGridItem) `
  ${StyledLineSeparator} {
    margin: 0;
  }
`;

export { StyledBottomListGridItem, StyledCopyrightGridItem, StyledFooterGrid, StyledFooterGridItem, StyledLineSeparatorGridItem, StyledTopListGridItem };
//# sourceMappingURL=Footer.styles.mjs.map
